module.exports = __webpack_public_path__ + "static/media/icon-piece3-4.b4f0c7aa.png";